import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Button, ProgressBar, InputGroup, Form } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { DataManager } from '../core/data-manager';
import { LoginManager } from '../core/login-manager';
import { ResourceManager } from '../core/resource-manager';
import { Helmet } from 'react-helmet';
import courseDefault from '../assets/course.jpg';
import banner from '../assets/continue/banner.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HomeCorsiInEvidenza from '../components/Home/HomeCorsiInEvidenza';
import CorsiInEvidenza from '../components/CorsiInEvidenza';
import CardContiua from '../components/Card/Continua';
import { ViewManager } from '../core/view-manager';
import { Utils } from '../core/utils';



export default function Materie() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const [search, setSearch] = useState("");
    const userInfo = LoginManager.getUserInfo();
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns('category'));

    useEffect(() => {
        getCategory()
    }, []);

    useEffect(() => {
        const timeOutId = setTimeout(() => getCategory(), 400);
        return () => clearTimeout(timeOutId);
    }, [search]);

    async function getCategory() {
        console.log(search)
        let constraints = [];
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var response = await DataManager.searchItems('category', 1, 1000, sorting, search, searchableFields, constraints)
        if (response.success === 1) {
            var t = response.body
            setData(t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }

    function goToSearch(id){
        navigate('/ricerca?category=' + id);
    }





    if (data) {
        return (
            <>
                <Helmet>
                    <title>{LanguageProvider.get('header.materia')}</title>
                </Helmet>

                <Container fluid className='text-white' style={{ backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '100%' }}>
                    <Container fluid={'md'}>
                        <Row style={{ paddingTop: '75px', paddingBottom: '75px' }}>
                            <Col>
                                <h2 className=''>Materie</h2>
                                <h6 className='' style={{ maxWidth: 600 }}>Seleziona una materia che desideri approfondire</h6>
                            </Col>
                        </Row>
                    </Container>

                </Container>


                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }

                {data && data.length > 0 ? (
                    <>
                        <Container fluid>
                            <Container fluid={'md'}>
                                <Row className='my-5 justify-content-end'>
                                    <Col md={3} className='ps-0'>
                                        <InputGroup>
                                            <Form.Control style={{ borderStartStartRadius: '20px', borderBottomLeftRadius: '20px', borderColor: 'var(--primary-color)', borderRight: '0' }}
                                                placeholder="Cerca" onChange={(e) => setSearch(e.target.value)}
                                            />
                                            <InputGroup.Text style={{ borderTopRightRadius: '20px', borderBottomRightRadius: '20px', borderLeft: '0', borderColor: 'var(--primary-color)', backgroundColor: 'white' }}>
                                                <FontAwesomeIcon icon='search'></FontAwesomeIcon></InputGroup.Text>
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row className='mt-5 mb-5'>
                                    {data.map((item, j) => {
                                        return (
                                            <Col xs={12} md={6} lg={4} key={j} className='py-3'>
                                                <Card style={{ backgroundColor: 'var(--primary-color)', minHeight: '150px' }} as={Button} className="w-100" onClick={()=> {goToSearch(item.id)}}>
                                                    <Card.Body
                                                        className="d-flex justify-content-center align-items-center text-center text-white py-4"
                                                        style={{ fontSize: '24px' }}
                                                    >
                                                        {item.name}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                    })}

                                </Row>

                            </Container>

                        </Container>
                        <CorsiInEvidenza />
                    </>
                ) : (
                    <><Row>
                        <Col className='text-center'>
                            <p className='text-muted text-center'>Nessuna corso completato.</p>
                            <Button className='rounded-pill' onClick={() => navigate('/corsi')}>Vai ai corsi</Button>
                        </Col>
                    </Row></>
                )}



            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};